import { keyframes } from '@vanilla-extract/css';
import { space } from '../tokens.ts';
import { style } from '../layer.css';

export const spin = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
});

export const spinner = style({
  border: '1.5px solid transparent',
  borderTopColor: 'inherit',
  borderLeftColor: 'inherit',
  borderRadius: '50%',
  animation: `${spin} 0.7s linear infinite`,
  margin: space.s2,
  flexShrink: 0,
});
